<template>
    <div class="app">
        <AppHeader fixed>
            <SidebarToggler class="d-lg-none" display="md" mobile />
            <b-link class="navbar-brand" to="#">
                <img :src="img" class="d-md-down-none" alt="" style="height: 50px">
            </b-link>
            <SidebarToggler class="d-md-down-none" display="lg" />
            <b-navbar-nav>
                <b-nav-item class="px-3" to="/">{{$t('home_page')}}</b-nav-item>
                <template v-if="pelev==0">
                    <b-nav-item class="px-3" to="/item">{{$t('main_data')}}</b-nav-item>
                </template>
                <template v-else>
                    <template v-for="(ret,index) in menus">
                        <template v-if="ret.Children!=undefined && ret.Children.length>0">
                            <b-nav-item-dropdown class="px-3" :text="$t(ret.Name)" :key="index">
                                <b-dropdown-item v-for="(sub,sid) in ret.Children" :to="sub.Url" :key="sid">{{$t(sub.Name)}}</b-dropdown-item>
                            </b-nav-item-dropdown>
                        </template>
                        <template v-else>
                            <b-nav-item class="px-3" :to="ret.Url" :key="index">{{$t(ret.Name)}}</b-nav-item>
                        </template>
                    </template>
                </template>
            </b-navbar-nav>
            <b-navbar-nav class="ml-auto">
                <li v-if="$store.state.userGroup==1" class="navbar-nav ml-auto">
                    <router-link to="/report/outofstock" class="nav-item-bor">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        <span class="badge badge-pill badge-danger">{{alertQty}}</span>
                    </router-link>
                </li>
                <DefaultHeaderDropdownAccnt/>
            </b-navbar-nav>
        </AppHeader>
        <div class="app-body">
            <AppSidebar fixed>
                <SidebarNav :navItems="nav"></SidebarNav>
            </AppSidebar>
            <main class="main">
                <router-view></router-view>
            </main>
            <AppAside fixed>
                <DefaultAside/>
            </AppAside>
        </div>
        <TheFooter>
            <div>
                <a href="https://www.khmerlearners.com">Khmer Learners</a>
                <span class="ml-1">&copy; 2020.</span>
            </div>
            <div class="ml-auto">
                <span class="mr-1">Powered by</span>
                <a href="https://www.khmerlearners.com">Khmer Learners</a>
            </div>
        </TheFooter>
    </div>
</template>
<script>
    import nav from '@/_nav'
    const AppHeader = () => import('@/views/layouts/Header.vue');
    const SidebarToggler = () => import('@/views/layouts/SidebarToggler.vue');
    const DefaultHeaderDropdownAccnt = () => import('./DefaultHeaderDropdownAccnt.vue');
    const TheFooter = () => import('@/views/layouts/Footer.vue');
    const AppAside = () => import('@/views/layouts/Aside.vue');
    const DefaultAside = () => import('./DefaultAside');
    import AppSidebar from '@/views/Sidebar/Sidebar';
    import SidebarNav from '@/views/Sidebar/SidebarNav';
    export default {
        name: 'DefaultContainer',
        components: {
            AppHeader,
            SidebarToggler,
            DefaultHeaderDropdownAccnt,
            TheFooter,
            AppAside,
            DefaultAside,
            AppSidebar,
            SidebarNav
        },
        data () {
            return {
                nav: [],
                menus: nav.menus,
                img: '/img/company-logo.png',
                alertQty: 0
            }
        },
        created(){
            this.getHeaderInfo();
            this.getCompany();
            this.moduleList();
        },
        methods: {
            getCompany: function() {
                this.$api().post("company").then(res => {
                    this.company = res.data.Data;
                    if(this.company.Logo != null){
                        this.img = this.$base() + 'image/logo/' + this.company.Logo;
                    }
                });
            },
            moduleList(){
                this.$api().post('user/group/modules', {}).then(res => {
                    if(this.$isValid(res)){
                        this.nav = res.data.Json.Modules;
                    }
                });
            },
            getHeaderInfo(){
                this.$api().post('header/info').then(res => {
                    if(this.$isValid(res)){
                        this.alertQty = res.data.Json.TotalAlert;
                    }
                });
            }
        },
        computed: {
            name () {
                return this.$route.name;
            },
            list () {
                return this.$route.matched.filter((route) => route.name || route.meta.label )
            },
            pelev(){
                return this.$store.state.userGroup;
            }
        }
    }
</script>
<style scoped>
    .main .container-fluid{
        padding: 0 20px;
    }
    .badge-pill{
        position: absolute;
        margin-top: -20px !important;
        top: 50%;
        line-height: 12px;
    }
    .nav-item-bor{
        border: 1px solid #ddd;
        padding: 8px 15px;
        border-radius: 3px;
    }

    .nav-item-bor:hover{
        border-color: green;
        cursor: pointer;
    }
</style>
